// Generated by Melange

import * as Buhta_cabinet__Route from "../../../Route.js";
import * as Buhta_cabinet__SidebarItem from "./SidebarItem.js";
import * as Buhta_cabinet__SidebarNestedItem from "./SidebarNestedItem.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__Auth from "../../../../../../packages/core/lib/Auth.js";
import * as Buhta_core__Tenant from "../../../../../../packages/core/lib/Tenant.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function SidebarHrm(Props) {
  let setBar = Props.setBar;
  let currentRoute = Props.currentRoute;
  let org = Props.org;
  let setIsDropdownShown = Props.setIsDropdownShown;
  const match = Buhta_core__Auth.IdentityContext.useIdentity(undefined);
  const identity = match[0];
  const match$1 = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match$1[0];
  const match$2 = React.useState(function () {
    return false;
  });
  const setIsProfileHovered = match$2[1];
  const isProfileHovered = match$2[0];
  const contextRoute = function (route) {
    return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
  };
  let userpic;
  let exit = 0;
  if (/* tag */ typeof identity === "number" || typeof identity === "string" || identity.TAG !== /* Authorized */ 0) {
    exit = 1;
  } else {
    const identityProfile = identity._0;
    userpic = identityProfile.userpic_url === "" ? JsxRuntime.jsx("div", {
        children: identityProfile.first_name.substring(0, 1),
        className: "w-5 h-5 rounded-full bg-asphalt flex justify-center items-center text-white text-xs font-semibold"
      }) : JsxRuntime.jsx("img", {
        className: "w-5 h-5 rounded-50pct",
        src: identityProfile.userpic_url
      });
  }
  if (exit === 1) {
    userpic = JsxRuntime.jsx("img", {
      className: "w-5 h-5 rounded-50pct",
      src: StaticAsset.src("/static/icons/profile-photo.png")
    });
  }
  let fullName;
  if (/* tag */ typeof identity === "number" || typeof identity === "string" || identity.TAG !== /* Authorized */ 0) {
    fullName = "Профиль";
  } else {
    const identityProfile$1 = identity._0;
    fullName = identityProfile$1.first_name + (" " + identityProfile$1.last_name);
  }
  let tmp;
  if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string" || currentRoute.TAG !== /* Org */ 6) {
    tmp = false;
  } else {
    let tmp$1 = currentRoute._1;
    tmp = /* tag */ typeof tmp$1 === "number" || typeof tmp$1 === "string" || tmp$1.TAG !== /* Hrm */ 5 ? false : true;
  }
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsxs("button", {
        children: [
          JsxRuntime.jsx("img", {
            className: "w-5 h-5",
            src: StaticAsset.src("/static/icons/back-arrow.svg")
          }),
          JsxRuntime.jsx(Buhta_components__Text.H4.make, {
            className: "ml-4 text-white",
            children: "Кадры"
          })
        ],
        className: "px-6 mt-8 mb-6 flex items-center",
        onClick: (function (param) {
          Curry._1(setBar, (function (param) {
            return "main";
          }));
        })
      }),
      JsxRuntime.jsx(Buhta_cabinet__SidebarNestedItem.make, {
        isActive: tmp,
        route: {
          TAG: /* Org */ 6,
          _0: org.id,
          _1: {
            TAG: /* Hrm */ 5,
            _0: {
              TAG: /* Employees */ 0,
              _0: /* Index */ 0
            }
          }
        },
        activeIcon: JsxRuntime.jsx("img", {
          className: "w-5 h-5",
          src: StaticAsset.src("/static/icons/people-white-20.svg")
        }),
        icon: JsxRuntime.jsx("img", {
          className: "w-5 h-5",
          src: StaticAsset.src("/static/icons/people-gray-20.svg")
        }),
        title: "Сотрудники"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Buhta_cabinet__SidebarItem.make, {
            item: {
              label: "Настройки",
              route: contextRoute({
                TAG: /* Settings */ 8,
                _0: /* General */ 0
              }),
              isActiveRoute: (function (param) {
                if (/* tag */ typeof param === "number" || typeof param === "string" || param.TAG !== /* Settings */ 8) {
                  return false;
                } else {
                  return true;
                }
              }),
              eventName: "",
              bar: "settings",
              isHidden: false
            },
            setBar: setBar
          }, "sidebar__item_settings"),
          JsxRuntime.jsxs("button", {
            children: [
              userpic,
              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                className: Cn.fromList({
                  hd: "ml-4",
                  tl: {
                    hd: isProfileHovered ? "text-white" : "text-gray-medium group-hover:text-white",
                    tl: /* [] */ 0
                  }
                }),
                children: fullName
              })
            ],
            className: Cn.fromList({
              hd: "px-6 flex py-1.5 hover:w-full",
              tl: {
                hd: isProfileHovered ? "bg-white/8" : "hover:bg-white/8",
                tl: /* [] */ 0
              }
            }),
            onClick: (function (param) {
              Curry._1(setIsDropdownShown, (function (param) {
                return true;
              }));
            }),
            onMouseEnter: (function (param) {
              Curry._1(setIsProfileHovered, (function (param) {
                return true;
              }));
            }),
            onMouseLeave: (function (param) {
              Curry._1(setIsProfileHovered, (function (param) {
                return false;
              }));
            })
          })
        ],
        className: "absolute bottom-6 space-y-2 w-[244px]"
      })
    ]
  });
}

const make = SidebarHrm;

export {
  make,
}
/* Buhta_cabinet__Route Not a pure module */
